import { useOverviewEditorState, useTile } from '../context'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { ArrowDown, ArrowUp, Pencil, Trash2, Undo2 } from 'lucide-react'
import { FormValues, MAIN_FIELD, SIDEBAR_FIELD } from '../form'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useGetTileName } from './TileWrapper'
import { OverviewTile } from '../defaults'

const TileControls = () => {
  const { index, tile: initialTileState } = useTile()
  const { onEditTile } = useOverviewEditorState()

  const form = useFormContext<FormValues>()

  const overviewSection =
    initialTileState.position === 'main' ? MAIN_FIELD : SIDEBAR_FIELD

  const tile: OverviewTile = form.watch(overviewSection)[index]
  const array = useFieldArray<FormValues>({
    name: overviewSection,
  })

  const getTileName = useGetTileName()

  return (
    <div
      className={cn(
        'absolute -top-px -right-px z-11 -bottom-px -left-px rounded-md border-2 border-dashed flex flex-col items-center justify-center gap-2 bg-background/50',
        tile._destroy ? 'border-destructive' : 'border-muted-foreground',
      )}
    >
      <h5 className='m-0 text-accent-foreground'>{getTileName(tile.type)}</h5>

      {tile._destroy ? (
        <Button
          variant='outline'
          size='sm'
          type='button'
          className='h-8'
          onClick={() =>
            form.setValue(`${overviewSection}.${index}._destroy`, false)
          }
        >
          <Undo2 className='h-4 w-4 mr-2' />
          Undo deletion
        </Button>
      ) : (
        <div className='flex items-center justify-center gap-2'>
          <Button
            variant='outline'
            size='icon'
            type='button'
            className='h-8 w-8'
            onClick={() => array.move(index, index - 1)}
            disabled={index === 0}
          >
            <ArrowUp className='h-4 w-4' />
          </Button>
          <Button
            variant='outline'
            size='icon'
            type='button'
            className='h-8 w-8'
            onClick={() => array.move(index, index + 1)}
            disabled={index === array.fields.length - 1}
          >
            <ArrowDown className='h-4 w-4' />
          </Button>
          <Button
            variant='outline'
            size='icon'
            type='button'
            className='h-8 w-8'
            onClick={() => onEditTile(tile, index)}
          >
            <Pencil className='h-4 w-4' />
          </Button>
          <Button
            variant='outline'
            size='icon'
            type='button'
            className='h-8 w-8 text-destructive-foreground hover:text-destructive-foreground'
            onClick={() => {
              if (tile.id) {
                form.setValue(`${overviewSection}.${index}._destroy`, true)
              } else {
                array.remove(index)
              }
            }}
          >
            <Trash2 className='h-4 w-4' />
          </Button>
        </div>
      )}
    </div>
  )
}

export default TileControls
